import React, { FunctionComponent } from "react";
import { generateQRMatrix } from "core/helpers/qrCodeGenerator";

interface QRCodeSVGProps {
  value: string;
  size?: number;
}

const QRCodeSVG: FunctionComponent<QRCodeSVGProps> = ({
  value,
  size = 200,
}) => {
  let matrix: boolean[][];
  try {
    matrix = generateQRMatrix(value);
  } catch {
    return null;
  }

  const cells = matrix.length;
  const cellSize = size / cells;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="QR code"
    >
      <rect width={size} height={size} fill="white" />
      {matrix.map((row, r) =>
        row.map(
          (dark, c) =>
            dark && (
              <rect
                key={`${r}-${c}`}
                x={c * cellSize}
                y={r * cellSize}
                width={cellSize}
                height={cellSize}
                fill="black"
              />
            )
        )
      )}
    </svg>
  );
};

export default QRCodeSVG;
